import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "preview", "filename", "filesize"]

  connect() {
    this.maxSize = 10 * 1024 * 1024 // 10MB
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    if (file.size > this.maxSize) {
      alert('File size exceeds maximum allowed (10MB)')
      this.inputTarget.value = ''
      return
    }

    this.showPreview(file)
  }

  showPreview(file) {
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove('hidden')
    }

    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = file.name
    }

    if (this.hasFilesizeTarget) {
      this.filesizeTarget.textContent = this.formatFileSize(file.size)
    }

    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.add('border-emerald-400', 'bg-emerald-50')
    }
  }

  remove() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add('hidden')
    }

    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove('border-emerald-400', 'bg-emerald-50')
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  dragOver(event) {
    event.preventDefault()
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.add('border-emerald-400')
    }
  }

  dragLeave(event) {
    event.preventDefault()
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove('border-emerald-400')
    }
  }

  drop(event) {
    event.preventDefault()
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove('border-emerald-400')
    }

    const files = event.dataTransfer.files
    if (files.length > 0 && this.hasInputTarget) {
      this.inputTarget.files = files
      this.fileSelected({ target: { files: files } })
    }
  }
}
